var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58329 17.5H3.74996C3.28972 17.5 2.91663 17.1269 2.91663 16.6667V3.33333C2.91663 2.8731 3.28972 2.5 3.74996 2.5H15.4166C15.8769 2.5 16.25 2.8731 16.25 3.33333V8.125",
    stroke: "#343434",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2651 11.25C16.2693 11.25 17.0833 12.0335 17.0833 13C17.0833 14.2582 15.8712 15.3333 15.2651 15.9167C14.8611 16.3055 14.356 16.6945 13.75 17.0833C13.1439 16.6945 12.6388 16.3055 12.2348 15.9167C11.6288 15.3333 10.4166 14.2582 10.4166 13C10.4166 12.0335 11.2307 11.25 12.2348 11.25C12.8672 11.25 13.4242 11.5608 13.75 12.0323C14.0757 11.5608 14.6327 11.25 15.2651 11.25Z",
    stroke: "#343434",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 5.83334H12.9167",
    stroke: "#343434",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.6c0e76eda6d398a0cbe09674a6f9bdf7.svg";
export { ForwardRef as ReactComponent };